<template>
  <div>
    <div class="location-search">
      <ValidationProvider v-slot="{ failed, errors }" name="Location" rules="required">
        <FormGroup
          id="location"
          title=""
          :errors="errors"
          inputClass="fullwidthInput"
          class="mb-4"
        >
           <template #title>
          <p class="mb-2">
            <span class="required-icon">*</span> {{ isClient ? 'Address' : 'Location'}}
            <span class="subLocation" v-if="!isClient"
              >(Confirm visit location. If it is different, start typing to
              update it)</span
            >
          </p>
           </template>
          <FormInputGroup
            v-model="query"
            name="location"
            placeholder="Select location"
            type="text"
            :invalid="failed"
            inputClass="fullwidthInputCustom"
            inputClasses="pl-3"
            :withIcon="true"
            @input="fetchSuggestions"
            autocomplete="off"
          >
            <template #icon>
                        <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="22"
              viewBox="0 0 16 22"
              fill="none"
            >
              <path
                d="M8.9875 20.8C11.125 18.125 16 11.6417 16 8C16 3.58333 12.4167 0 8 0C3.58333 0 0 3.58333 0 8C0 11.6417 4.875 18.125 7.0125 20.8C7.525 21.4375 8.475 21.4375 8.9875 20.8ZM8 5.33333C8.70724 5.33333 9.38552 5.61428 9.88562 6.11438C10.3857 6.61448 10.6667 7.29276 10.6667 8C10.6667 8.70724 10.3857 9.38552 9.88562 9.88562C9.38552 10.3857 8.70724 10.6667 8 10.6667C7.29276 10.6667 6.61448 10.3857 6.11438 9.88562C5.61428 9.38552 5.33333 8.70724 5.33333 8C5.33333 7.29276 5.61428 6.61448 6.11438 6.11438C6.61448 5.61428 7.29276 5.33333 8 5.33333Z"
                fill="black"
                fill-opacity="0.25"
              />
            </svg>

            </template>
          </FormInputGroup>
          <ul v-if="suggestions.length" class="suggestions-list">
            <li
              v-for="(suggestion, index) in suggestions"
              :key="index"
              @click="selectLocation(suggestion)"
            >
              {{ suggestion.description }}
            </li>
          </ul>
          <!-- Address validation error message -->
          <div v-if="addressError" class="mt-2 p-3 bg-red-50 border border-red-200 rounded-md">
            <div class="flex">
              <svg class="w-5 h-5 text-red-400" fill="currentColor" viewBox="0 0 20 20">
                <path fill-rule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clip-rule="evenodd" />
              </svg>
              <div class="ml-3">
                <p class="text-sm text-red-700">{{ addressError }}</p>
                <p class="text-xs text-red-600 mt-1">Try searching for a street address like "123 Main Street, Toronto, ON"</p>
              </div>
            </div>
          </div>
        </FormGroup>
      </ValidationProvider>
    </div>
<div v-if="!isClient" class="mb-4">
      <div class="flex items-center gap-2 mb-2">
        <input
          type="checkbox"
          id="geofence-enabled"
          v-model="internalCheckGeo"
          @change="onCheckGeoChange"
          class="w-4 h-4 rounded border-gray-300 text-primary-500 focus:ring-primary-500"
        />
        <label
          for="geofence-enabled"
          class="text-sm font-medium cursor-pointer select-none"
          :class="internalCheckGeo ? 'text-gray-900' : 'text-gray-500'"
        >
          Geofence check in radius size is 70 metres.
        </label>
      </div>
      <div v-if="internalCheckGeo" class="flex items-center gap-2 wraningBorder flex-wrap text-black/88">
        <div class="flex gap-2 items-center">
          <InfoCircleFilled />
          <span class="text-sm">Geofencing is enabled for this visit</span>
        </div>
      </div>
    </div>

    <div v-if="showMap" class="map-container">
      <div v-if="!isClient">
      <div ref="mapContainer" class="map-element"></div>
      <a
        v-if="googleMapsLink"
        :href="googleMapsLink"
        target="_blank"
        class="google-maps-link"
      >
        View on Google Maps
      </a>
      </div>
    </div>
  </div>
</template>

<script>
import { VUE_GOOGLEMAP_API_KEY } from "@/data/constants";
import FormGroup from "@/components/form/FormGroupNew.vue";
import InfoCircleFilled from "@/components/icons/InfoCircleFilledYellow.vue";
import FormInputGroup from "@/components/form/FormInputGroupNew.vue";
import { getTimezoneFromCoordinates } from "@/utils/timezoneUtils";
export default {
  components: {
    FormGroup,
    InfoCircleFilled,
    FormInputGroup,
  },
  props: {
    location: {
      type: String,
      default: "",
    },
    isClient: {
      type: Boolean,
      default: true,
    },
    checkGeo: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      query: "",
      googleMapsLink: "",
      suggestions: [],
      selectedLocation: null,
      selectedTimezone: null,
      map: null,
      marker: null,
      autocompleteService: null,
      placesService: null,
      googleMapsLoaded: false,
      showMap: false,
      addressError: "",
      internalCheckGeo: true,
    };
  },
  watch: {
    location: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.initializeWithLocation(newVal);
        }
      },
    },
    checkGeo: {
      immediate: true,
      handler(newVal) {
        this.internalCheckGeo = newVal;
      },
    },
  },
  async mounted() {
    await this.loadGoogleMaps();
    if (this.location) {
      await this.initializeWithLocation(this.location);
    }
  },
  methods: {
    async loadGoogleMaps() {
      if (this.googleMapsLoaded) return;

      return new Promise((resolve, reject) => {
        if (window.google && window.google.maps) {
          this.googleMapsLoaded = true;
          this.initServices();
          resolve();
          return;
        }

        const script = document.createElement("script");
        script.src = `https://maps.googleapis.com/maps/api/js?key=${VUE_GOOGLEMAP_API_KEY}&libraries=places`;
        script.async = true;
        script.defer = true;
        script.onload = () => {
          this.googleMapsLoaded = true;
          this.initServices();
          resolve();
        };
        script.onerror = (error) => {
          console.error("Google Maps script failed to load", error);
          reject(error);
        };
        document.head.appendChild(script);
      });
    },
    initServices() {
      this.autocompleteService = new google.maps.places.AutocompleteService();
      this.placesService = new google.maps.places.PlacesService(
        document.createElement("div")
      );
    },
    async initializeWithLocation(locationString) {
      if (!locationString?.trim()) return;

      this.query = locationString;
      this.selectedLocation = { description: locationString };

      await this.$nextTick();

      try {
        const place = await this.findPlace(locationString);
        if (place) {
          const location = place.geometry.location;
          const lat = location.lat();
          const lng = location.lng();
          
          // Get timezone information for the existing location
          const timezone = await getTimezoneFromCoordinates(lat, lng, VUE_GOOGLEMAP_API_KEY);
          this.selectedTimezone = timezone;
          
          this.showMap = true;
          await this.$nextTick();
          this.initMap(lat, lng);
          this.googleMapsLink = this.generateGoogleMapsLink(place);
          
          // Emit location with timezone for existing locations too
          if (timezone) {
            this.$emit("locationAdded", {
              description: locationString,
              timezone: timezone,
              coordinates: { lat, lng }
            });
          }
        }
      } catch (error) {
        console.error("Error initializing with location:", error);
      }
    },
    findPlace(query) {
      return new Promise((resolve) => {
        const request = {
          query,
          fields: ["name", "formatted_address", "geometry"],
        };

        this.placesService.findPlaceFromQuery(request, (results, status) => {
          if (
            status === google.maps.places.PlacesServiceStatus.OK &&
            results?.length
          ) {
            resolve(results[0]);
          } else {
            console.error("Place not found:", status);
            resolve(null);
          }
        });
      });
    },
    fetchSuggestions() {
      // Clear error when user starts typing a new search
      this.addressError = "";
      
      if (this.query.length < 3) {
        this.suggestions = [];
        return;
      }

      const request = {
        input: this.query,
        componentRestrictions: { country: "CA" },
      };

      this.autocompleteService.getPlacePredictions(
        request,
        (predictions, status) => {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            this.suggestions = predictions;
          } else {
            console.error("Error fetching suggestions:", status);
            this.suggestions = [];
          }
        }
      );
    },
    async selectLocation(location) {
      this.selectedLocation = location;
      this.query = location.description;
      this.suggestions = [];
      this.addressError = ""; // Clear any previous errors

      try {
        const place = await this.getPlaceDetails(location.place_id);
        if (place) {
          // Validate address specificity
          const validation = this.validateAddressSpecificity(place);
          
          if (!validation.isValid) {
            this.addressError = validation.error;
            // Don't proceed with selection if validation fails
            return;
          }

          const locations = place.geometry.location;
          const lat = locations.lat();
          const lng = locations.lng();
          
          // Get timezone information for the location
          const timezone = await getTimezoneFromCoordinates(lat, lng, VUE_GOOGLEMAP_API_KEY);
          this.selectedTimezone = timezone;
          
          this.showMap = true;
          await this.$nextTick();
          this.initMap(lat, lng);
          this.googleMapsLink = this.generateGoogleMapsLink(place);
          
          // Emit location with timezone information
          this.$emit("locationAdded", {
            description: location.description,
            place_id: location.place_id,
            timezone: timezone,
            coordinates: { lat, lng }
          });
        }
      } catch (error) {
        console.error("Error selecting location:", error);
        this.addressError = "Error processing location. Please try again.";
      }
    },
    getPlaceDetails(placeId) {
      return new Promise((resolve) => {
        const request = {
          placeId,
          fields: ["name", "formatted_address", "geometry", "types", "address_components"],
        };

        this.placesService.getDetails(request, (place, status) => {
          if (status === google.maps.places.PlacesServiceStatus.OK) {
            resolve(place);
          } else {
            console.error("Error getting place details:", status);
            resolve(null);
          }
        });
      });
    },
    validateAddressSpecificity(place) {
      if (!place) {
        return { isValid: false, error: "Invalid location data" };
      }

      const types = place.types || [];
      const addressComponents = place.address_components || [];

      // Check for specific address types that indicate a street address
      const specificAddressTypes = [
        'street_address',
        'premise', 
        'subpremise',
        'establishment'
      ];

      // Check if place has any specific address types
      const hasSpecificType = types.some(type => specificAddressTypes.includes(type));
      
      if (hasSpecificType) {
        return { isValid: true };
      }

      // Check for street number and route in address components
      const hasStreetNumber = addressComponents.some(component => 
        component.types.includes('street_number')
      );
      const hasRoute = addressComponents.some(component => 
        component.types.includes('route')
      );

      if (hasStreetNumber && hasRoute) {
        return { isValid: true };
      }

      // Check for broad location types that should be rejected
      const broadLocationTypes = [
        'locality',           // City
        'administrative_area_level_1', // Province/State  
        'administrative_area_level_2', // County
        'country',           // Country
        'postal_code',       // Postal code only
        'sublocality',       // Area within city
        'neighborhood'       // Neighborhood
      ];

      const hasBroadType = types.some(type => broadLocationTypes.includes(type));
      const hasOnlyBroadTypes = hasBroadType && !types.some(type => !broadLocationTypes.includes(type));

      if (hasOnlyBroadTypes) {
        return { 
          isValid: false, 
          error: "Please enter a specific street address, not just a city or area name" 
        };
      }

      // Fallback: Check formatted address for street indicators
      const formattedAddress = place.formatted_address || '';
      const streetIndicators = /\b(\d+\s+\w+\s+(st|street|ave|avenue|blvd|boulevard|rd|road|dr|drive|way|lane|ln|ct|court|pl|place|cir|circle))\b/i;
      
      if (streetIndicators.test(formattedAddress)) {
        return { isValid: true };
      }

      return { 
        isValid: false, 
        error: "Please select a specific street address for the visit location"
      };
    },
    onCheckGeoChange() {
      this.$emit('checkGeoChanged', this.internalCheckGeo);
    },
    initMap(lat, lng) {
      if (!this.$refs.mapContainer) return;

      // Clear existing map if it exists
      if (this.map) {
        this.marker.setMap(null);
        google.maps.event.clearInstanceListeners(this.map);
      }

      // Create new map
      this.map = new google.maps.Map(this.$refs.mapContainer, {
        center: { lat, lng },
        zoom: 16,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        // Disable user interactions
        scrollwheel: false,
        panControl: false,
        zoomControl: false,
        gestureHandling: 'none',
        draggable: false,
        disableDoubleClickZoom: true,
        keyboardShortcuts: false,
        streetViewControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
      });

      // Add marker
      this.marker = new google.maps.Marker({
        position: { lat, lng },
        map: this.map,
      });

      // Force resize and recenter
      setTimeout(() => {
        google.maps.event.trigger(this.map, "resize");
        this.map.setCenter({ lat, lng });
      }, 100);
    },
    generateGoogleMapsLink(place) {
      return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
        place.formatted_address || place.name || this.query
      )}`;
    },
  },
};
</script>

<style scoped>
.location-search {
  margin-bottom: 1rem;
}

.suggestions-list {
  list-style-type: none;
  padding: 0;
  margin: 0;
  max-height: 150px;
  overflow-y: auto;
  margin-top: 5px;
  border-radius: 8px;
  background: var(--colorBgElevated, #fff);
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
    0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 6px 16px 0px rgba(0, 0, 0, 0.08);
}


.map-container {
  margin-bottom: 0.625rem;
}

.map-element {
  width: 100%;
  height: 360px;
  background-color: #f5f5f5;
}

.google-maps-link {
  display: inline-block;
  margin-top: 0.5rem;
  font-weight: 400;
  font-size: 0.875rem;
  color: #016bff !important;
  line-height: normal;
  color: var(--notification-blue);
}

.required-icon {
  color: #ff766e;
  margin-right: 4px;
}

.subLocation {
  color: var(--colorTextDescription, rgba(0, 0, 0, 0.45));
  font-family: Outfit;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.wraningBorder {
  margin-bottom: 1rem;
  color: #717986;
font-family: Outfit;
font-size: 12px;
font-style: normal;
font-weight: 400;
line-height: 120%; 
border-radius: 6px;
  background: #F9F9F9;
  width: 100%;
  line-height: normal;
  padding: 8px 16px;
}
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
  border: 1px solid #ccc;
  max-height: 150px;
  overflow-y: auto;
}

li {
  padding: 8px;
  cursor: pointer;
}

li:hover {
  background-color: #f0f0f0;
}
.required-icon {
  color: #ff766e;
  margin-right: 4px;
}
.subLocation {
  color: var(--colorTextDescription, rgba(0, 0, 0, 0.45));
  font-family: Outfit;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.multiselect__content_map {
  max-height: 300px;
  margin-top: 5px;
  border-radius: 8px;
  background: var(--colorBgElevated, #fff);
  border: 1px solid white;
  box-shadow: 0px 9px 28px 8px rgba(0, 0, 0, 0.05),
    0px 3px 6px -4px rgba(0, 0, 0, 0.12), 0px 6px 16px 0px rgba(0, 0, 0, 0.08);
}
.multiselect__element_map {
  color: var(--colorText, rgba(0, 0, 0, 0.88));
  font-family: Outfit;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}
.multiselect__element_map:hover {
  font-size: 16px;
  font-weight: 500;
  border-radius: 4px;
  background: rgba(242, 183, 5, 0.5);
}
</style>